import api from "./api";

const DASHBOARD_BASE = "/api/v1/orders/dashboard";

function buildDashboardParams({ companyId, userId, userRole, dateFrom, dateTo }) {
  const params = {
    company_id: companyId,
    user_id: userId,
    role: String(userRole || "").toLowerCase().trim(),
  };
  if (dateFrom) params.date_from = dateFrom;
  if (dateTo) params.date_to = dateTo;
  return params;
}

export async function fetchOrderDashboardStats({
  companyId,
  userId,
  userRole,
  dateFrom,
  dateTo,
}) {
  const res = await api.get(`${DASHBOARD_BASE}/stats`, {
    params: buildDashboardParams({ companyId, userId, userRole, dateFrom, dateTo }),
  });
  return res.data?.data ?? null;
}

export async function fetchOrderDashboardClientWise({
  companyId,
  userId,
  userRole,
  dateFrom,
  dateTo,
}) {
  const res = await api.get(`${DASHBOARD_BASE}/client-wise`, {
    params: buildDashboardParams({ companyId, userId, userRole, dateFrom, dateTo }),
  });
  return res.data?.data ?? [];
}

export async function fetchOrderDashboardPlatformWise({
  companyId,
  userId,
  userRole,
  dateFrom,
  dateTo,
}) {
  const res = await api.get(`${DASHBOARD_BASE}/platform-wise`, {
    params: buildDashboardParams({ companyId, userId, userRole, dateFrom, dateTo }),
  });
  return res.data?.data ?? [];
}

export async function fetchOrderDashboardVendorWise({
  companyId,
  userId,
  userRole,
  dateFrom,
  dateTo,
}) {
  const res = await api.get(`${DASHBOARD_BASE}/vendor-wise`, {
    params: buildDashboardParams({ companyId, userId, userRole, dateFrom, dateTo }),
  });
  return res.data?.data ?? [];
}
